import { render, staticRenderFns } from "./ExpedientePersonalSection.vue?vue&type=template&id=5a8bba9f&scoped=true"
import script from "./ExpedientePersonalSection.vue?vue&type=script&lang=js"
export * from "./ExpedientePersonalSection.vue?vue&type=script&lang=js"
import style0 from "./ExpedientePersonalSection.vue?vue&type=style&index=0&id=5a8bba9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8bba9f",
  null
  
)

export default component.exports